import LoginComponent from './login-component';
import UiActions from '../logic/ui-actions';
import LoginForm from './login-form';

import './login-bubble.scss';

export default class LoginBubble extends LoginComponent {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();

        // We have to break outside of React's scope, because there's no built-in way for a universal
        // click handler on the whole document. See https://github.com/facebook/react/issues/579
        let body = document.getElementsByTagName('body')[0];
        const componentId = this.state.componentId;

        if (body.addEventListener) {
            body.addEventListener('click', (e) => {
                LoginBubble._handleOutsideClick(e, componentId);
            });
        } else { // IE8 support
            body.attachEvent('onclick', (e) => {
                LoginBubble._handleOutsideClick(e, componentId);
            });
        }
    }

    static _handleCloseClick(componentId) {
        UiActions.hideBubble(componentId);
    }

    static _handleOutsideClick(event, componentId) {
        if (!LoginBubble._isClickedInsideBubble(event)) {
            UiActions.hideBubble(componentId);
        }
    }

    static get id() {
        return 'login-bubble';
    }

    static _isClickedInsideBubble(event) {
        var element = event.target;

        if (element.getAttribute('id') === LoginBubble.id) {
            return true;
        }

        while (element.parentNode && element.parentNode.getAttribute) {
            element = element.parentNode;
            if (element.getAttribute('id') === LoginBubble.id) {
                return true;
            }
        }

        return false;
    }

    get closedClass() {
        return !this.state.uiState.bubble.isBubbleVisible ? ' closed' : '';
    }

    get bubbleStyles() {
        const position = this.state.uiState.bubble.position;

        return {
            top: `${position.top}px`,
            left: `${position.left}px`
        };
    }

    get arrowStyles() {
        const position = this.state.uiState.bubble.position;
        const arrowHeight = 20;
        const arrowWidth = 40;

        return {
            top: `${-(arrowHeight - 1)}px`,
            left: `${position.width / 2 - arrowWidth / 2 + position.overflow}px`
        };
    }

    render() {
        const bubbleClass = `login-component login-bubble${this.closedClass}`;

        return (
            <div className="jwf-login">

                <div id={LoginBubble.id}
                     className={bubbleClass}
                     style={this.bubbleStyles}>

                    <div style={this.arrowStyles}
                         className="bubble-arrow">
                    </div>

                <LoginForm svgLoaded={true} componentId={this.state.componentId} />
            </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/login-bubble.jsx
 **/